import React, { useEffect, useState } from "react";
import { Grid, Button, Typography, CircularProgress, MenuItem, FormControl, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Autocomplete } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";




import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../App";
import { format } from "date-fns"; 
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 

const login_id = localStorage.getItem("LOGIN_ID");
const ServiceClaimLedger = () => {
  const [ascOptions, setAscOptions] = useState([]);
  const [selectedAsc, setSelectedAsc] = useState(null); 
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [ledgerData, setLedgerData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAscList = async () => {
      try {
        const loginId = login_id; 
        
        const response = await axios.post(`${BASE_URL}/getAscList`, { loginId });
        setAscOptions(response.data);
      } catch {
        Swal.fire("Error", "Failed to load ASC list.", "error");
      }
    };
  
    fetchAscList();
  }, []);

  const handleView = async () => {
    if (!selectedAsc || !fromDate || !toDate) {
      Swal.fire("Validation", "Please select ASC and date range.", "warning");
      return;
    }
  
    const diffInDays = (toDate - fromDate) / (1000 * 60 * 60 * 24);
    if (diffInDays > 31) {
      Swal.fire("Warning", "Maximum allowed range is 31 days.", "warning");
      return;
    }
  
    setLoading(true);
    setLedgerData([]);
  
    try {
     
      // const formattedFromDate = format(fromDate, "yyyy-MM-dd");
      // const formattedToDate = format(toDate, "yyyy-MM-dd");

      const formattedFromDate = format(fromDate.toDate(), "yyyy-MM-dd");
const formattedToDate = format(toDate.toDate(), "yyyy-MM-dd");

  
      const response = await axios.post(`${BASE_URL}/getServiceClaimLedger`, {
        fromdate: formattedFromDate,
        todate: formattedToDate,
        asc_code: selectedAsc.value, 
      });
  
      if (response.data?.length > 0) {
        setLedgerData(response.data);
      } else {
        Swal.fire("No Data", "No records found for selected range.", "info");
      }
    } catch (error) {
      Swal.fire("Error", "Failed to fetch ledger data.", "error");
    } finally {
      setLoading(false);
    }
  };
  
  

  const handleExport = () => {
    if (!selectedAsc || !fromDate || !toDate) {
      Swal.fire("Validation", "Please select ASC and date range.", "warning");
      return;
    }
  
    if (ledgerData.length === 0) {
      Swal.fire("No Data", "No data available to export.", "info");
      return;
    }
  

    const worksheet = XLSX.utils.json_to_sheet(ledgerData);
  
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ServiceClaimLedger");
  
   
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
  
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    const fileName = `Service_Claim_Ledger_${format(new Date(), "yyyyMMdd_HHmmss")}.xlsx`;
    saveAs(data, fileName);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>

      <Paper elevation={3} style={{ padding: 24, marginTop: 32 }}>
        <Typography variant="h5" gutterBottom>
          Service Claim Ledger
        </Typography>

        <Grid container spacing={3} alignItems="center" marginBottom={3}>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <Autocomplete
                value={selectedAsc}
                onChange={(event, newValue) => setSelectedAsc(newValue)}
                options={ascOptions}
                getOptionLabel={(option) => option.label} 
                renderInput={(params) => <TextField {...params} label="ASC Code" />}
                isOptionEqualToValue={(option, value) => option.value === value.value} 
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <DatePicker
              label="From Date"
              value={fromDate}
              onChange={(newValue) => setFromDate(newValue)}
              renderInput={(params) => <TextField fullWidth {...params} />}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <DatePicker
              label="To Date"
              value={toDate}
              onChange={(newValue) => setToDate(newValue)}
              renderInput={(params) => <TextField fullWidth {...params} />}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleView}
                >
                  View
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="success"
                  onClick={handleExport}
                >
                  Export
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {loading && (
          <Grid container justifyContent="center">
            <CircularProgress />
          </Grid>
        )}

        {ledgerData.length > 0 && (
          <TableContainer component={Paper} sx={{ mt: 4 }}>
       <Table>
  <TableHead>
    <TableRow sx={{ backgroundColor: '#ADD8E6' }}> {/* Light blue color */}
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>Branch Code</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>ASC Code</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>ASC Name</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>Doc No</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>Doc Date</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>Serial No</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>Admin Approval</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>Admin Approval Date</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>BM Approval</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>BM Approval Date</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>GJV Creation Status</TableCell>
      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>GJV Date</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {ledgerData.map((item, index) => (
      <TableRow key={index}>
        <TableCell>{item.BRANCH_CODE}</TableCell>
        <TableCell>{item.ASC_CODE}</TableCell>
        <TableCell>{item.ASC_NAME}</TableCell>
        <TableCell>{item.DOC_NO}</TableCell>
        <TableCell>{item.DOC_DATE}</TableCell>
        <TableCell>{item.SERIAL_NO}</TableCell>
        <TableCell>{item.ADMIN_APPROVAL}</TableCell>
        <TableCell>{item.ADMIN_APPROVED_DATE}</TableCell>
        <TableCell>{item.BM_APPROVAL}</TableCell>
        <TableCell>{item.BM_APPROVED_DATE}</TableCell>
        <TableCell>{item.GJV_CREATION_STATUS}</TableCell>
        <TableCell>{item.GJV_DATE}</TableCell>
      </TableRow>
    ))}
  </TableBody>
</Table>



          </TableContainer>
        )}
      </Paper>
    </LocalizationProvider>
  );
};

export default ServiceClaimLedger;
